// extracted by mini-css-extract-plugin
module.exports = {"titleStyle":"WhoWeAre_titleStyle__28vHV","titleSecondSection":"WhoWeAre_titleSecondSection__1uxWJ","descriptionSecondSection":"WhoWeAre_descriptionSecondSection__2Sl2e"};